import { Rings } from "@/components/Rings";

const ITEMS = [
  "Dream it. Plan it. Live it.",
  "From Queensland to the world",
  "A family of five brands",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif-display italic text-lg sm:text-xl text-[#757882] px-8 whitespace-nowrap">
          {item}
        </span>
        <Rings size={14} stroke="#B69766" opacity={0.7} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-[#1A1C23]/10 py-5 select-none"
    aria-hidden="true"
  >
    <div className="marquee-track">
      <Row />
      <Row />
      <Row />
      <Row />
    </div>
  </div>
);
